import _extends from '@babel/runtime-corejs3/helpers/extends';
import React__default from 'react';
import classNames from 'classnames';
import menuStyles from '../NewMenu.js';
import MenuItem from './MenuItem.js';
import '../../../icons/index.es.js';
import ChevronRightIcon from '../../../icons/components/ChevronRightIcon.js';

const SubmenuAnchor = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    label,
    className,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement(MenuItem, _extends({
    "aria-haspopup": "menu",
    className: classNames(className, menuStyles.subMenu),
    ref: ref
  }, rest), label, /*#__PURE__*/React__default.createElement(ChevronRightIcon, {
    className: menuStyles.rightIcon,
    "aria-hidden": "true"
  }));
});

export { SubmenuAnchor as default };
